import defaultSettings from '@/settings'
import { translateMenuTitle } from '@/utils/menu-title'

const title = defaultSettings.title || 'Vue Element Admin'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${translateMenuTitle(pageTitle, pageTitle)} - ${title}`
  }
  return `${title}`
}
